import { useTranslate, HttpError } from '@refinedev/core';
import { Create, useForm, useSelect } from '@refinedev/antd';
import { Form, Input, Select, Switch } from 'antd';
import type {
  TestimonialOut,
  TestimonialCreateIn,
} from '@/api/generated/schemas';

export const TestimonialCreate = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps } = useForm<
    TestimonialOut,
    HttpError,
    TestimonialCreateIn
  >({
    resource: 'feedback.testimonials',
  });

  const { selectProps: publicationSelectProps } = useSelect({
    resource: 'user_catalog.publications',
    optionLabel: 'title',
    optionValue: 'id',
    onSearch: (value) => [{ field: 'q', operator: 'contains', value }],
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          name="publication_id"
          label={t('feedback.testimonials.fields.publication_id')}
          rules={[{ required: true }]}
        >
          <Select
            {...publicationSelectProps}
            showSearch
            filterOption={false}
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          name="author_name"
          label={t('feedback.testimonials.fields.author_name')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="comment"
          label={t('feedback.testimonials.fields.comment')}
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          name="is_promoted"
          label={t('feedback.testimonials.fields.is_promoted')}
          valuePropName="checked"
          initialValue={false}
        >
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  );
};
